import React, {useCallback, useState, useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import * as S from './PopularitySort.styles';

import ArrowBlueDown from '../../../../Icons/ArrowBlueDown';

import {updateSrpConfigAction} from '../../../../../shared/pages/SRP/redux/actions';
import {fetchSrpDataThunk} from '../../../../../shared/pages/SRP/redux/thunks';
import {ISrpConfig} from '../../../../../shared/pages/SRP/redux/types';

import {sortingKeyLabelMap} from './../../../../../shared/config/app-config';

import {srpConfigSelectorFn} from '../../../../../shared/pages/SRP/redux/selectors';

const PopularitySort = () => {
  const srpConfig = useSelector(srpConfigSelectorFn);

  const dispatch = useDispatch();

  const updateSortingCaller = (actionData: string) => {
    dispatch(updateSrpConfigAction({s: actionData} as ISrpConfig));
    dispatch(fetchSrpDataThunk());
  };

  const {s: sortingValue} = srpConfig as ISrpConfig;

  return (
    <S.SortingOuterWrap>
      <S.SortingText>Sorted by</S.SortingText>
      <S.SelctedTextWrap>
        <S.SortSelectedText>{sortingKeyLabelMap[sortingValue]}</S.SortSelectedText>
        <ArrowBlueDown width="2.4rem" height="1.8rem" />

        <S.HiddenDropdownWrapperDiv>
          <S.TopDiv>
            <S.ListDropDownWrapper>
              {Object.keys(sortingKeyLabelMap).map((itemKey, index) => (
                <li
                  key={itemKey + index}
                  onClick={() => {
                    updateSortingCaller(itemKey);
                  }}
                >
                  <S.RadioCheck name={'sortingType'} checked={itemKey === sortingValue} onChange={() => {}} />
                  <S.FontBigBold>{sortingKeyLabelMap[itemKey]}</S.FontBigBold>
                </li>
              ))}
            </S.ListDropDownWrapper>
            {/* <S.TipPositioning /> */}
          </S.TopDiv>
        </S.HiddenDropdownWrapperDiv>
      </S.SelctedTextWrap>
    </S.SortingOuterWrap>
  );
};

export default PopularitySort;
